<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox">
        <el-form-item label="出库时间:">
          <el-date-picker
            v-model="searchFrom.dates"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="客户名称:" >
          <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
        </el-form-item>
        <el-form-item label="货物名称:" >
          <el-input  placeholder="" v-model="searchFrom.productTypeName"></el-input>
        </el-form-item>
        <el-form-item label="所属仓库:"  v-if="userType==1">
          <el-select  v-model="searchFrom.organizationName" filterable placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in cklist" :label="item.remark" :value="item.remark" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
         <div class="searchBtnBox">
          <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
          <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
          <el-button type="primary" size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
          <!-- <el-button type="primary" v-if="btnFlg[1]" @click="addFn" size="mini" >新增</el-button>
          <el-button type="primary" v-if="btnFlg[2]" @click="delFn" size="mini" >删除</el-button> -->
          <el-form-item style="padding-left: 10px;">
            <p class="margin0">出库量合计:<span class="red">{{tongji.allWeight}}</span>吨</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent"  @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <!-- <el-table-column label="操作" width="160" >
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" v-if="btnFlg[3]"  @click="editFn(scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="所属仓库"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物名称"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockWeight" label="重量(吨)"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号"   min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机"   min-width="220"></el-table-column>
        <el-table-column prop="operationTime" label="出库时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人"  min-width="120"></el-table-column> -->
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="isAdd?'出库作业':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="850px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="addForm" :model="addForm"  class="demo-form-inline jiaoyan"  label-width="110px"  size="mini"  >
          <el-form-item label="客户名称:" prop="customerName" >
           <el-select placeholder="请选择" value-key="customerName"  filterable allow-create
            default-first-option v-model="addForm.customerName">
              <el-option v-for="item in kehuList" :key="item.customerName" :label="item.customerName" :value="item.customerName"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="车牌号:" prop="plateNumber" >
            <el-input  placeholder=""   maxlength="8" v-model="addForm.plateNumber"  ></el-input>
          </el-form-item>
          <el-form-item label="司机:"  >
            <el-input  placeholder=""   maxlength="8" v-model="addForm.driverName"  ></el-input>
          </el-form-item>
           <el-form-item label="货物名称:" prop="productTypeName" >
            <el-select placeholder="请选择" value-key="productTypeName"  filterable allow-create
            default-first-option v-model="addForm.productTypeName">
              <el-option v-for="item in hwlxList" :key="item.productTypeName" :label="item.productTypeName" :value="item.productTypeName"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="重量(吨):" prop="stockWeight" >
            <el-input  placeholder=""   maxlength="8" v-number-input.float="3" v-model="addForm.stockWeight"  ></el-input>
          </el-form-item>
           <el-form-item label="规格:"  >
            <el-input  placeholder=""   maxlength="8" v-model="addForm.specification"  ></el-input>
          </el-form-item>
           <el-form-item label="材质:"  >
            <el-input  placeholder=""   maxlength="8" v-model="addForm.model"  ></el-input>
          </el-form-item>
          <el-form-item label="出库时间:" prop="operationTime" label-width="120px">
            <el-date-picker
              v-model="addForm.operationTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
            ></el-date-picker>
        </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed, getLastWeekDates } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findDisplayOperationList, findDisplayOperationStatistics, deleteDisplayOperation, addDisplayOperationList,
  updateDisplayOperation, findCustomerDropDownBox, findDisplayOperationBox, findShWhList } from '@/api/data-center-server'
export default {
  components: {
  },
  data () {
    return {
      isDain: true,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      rules: {
        customerName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        productTypeName: [
          { required: true, message: '请输入货物名称', trigger: 'blur' }
        ],
        stockWeight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        operationTime: [
          { required: true, message: '请选择出库时间', trigger: 'blur' }
        ]
      },
      isAdd: false,
      addFlag: false,
      addForm: { },
      tongji: {},
      kehuList: [],
      hwlxList: [],
      userType: localStorage.getItem('userType'),
      btnFlg: [],
      btnIdArr: ['00CM0N0100', '00CM0N0200', '00CM0N0300', '00CM0N0400']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    findShWhList().then(res => {
      this.cklist = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
    this.$set(this.searchFrom, 'dates', getLastWeekDates())
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 添加
    addFn () {
      findCustomerDropDownBox().then(res => {
        this.kehuList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
      findDisplayOperationBox().then(res => {
        this.hwlxList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
      this.addForm = {}
      this.isAdd = true
      this.$set(this.addForm, 'operationTime', new Date().getTime())
      this.addFlag = true
    },
    // 修改
    editFn  (row) {
      this.addForm = { ...row }
      this.isAdd = false
      this.addFlag = true
    },
    saveFn () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.addForm.date = this.addForm.operationTime
          if (this.isAdd) {
            this.addForm.operationType = 2// 1：入库 2：出库
            addDisplayOperationList([this.addForm]).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            updateDisplayOperation(this.addForm).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteDisplayOperation({
          ids: selectData.map(item => item.id)
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.wmsCenter + '/displayOperation/exportDisplayOperationList',
        form,
        '出库列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.dates) {
        this.$set(this.searchFrom, 'startOperationTime', this.searchFrom.dates[0])
        this.$set(this.searchFrom, 'endOperationTime', this.searchFrom.dates[1])
      } else {
        this.$set(this.searchFrom, 'startOperationTime', null)
        this.$set(this.searchFrom, 'endOperationTime', null)
      }
      this.searchFrom.operationType = 2// 1：入库 2：出库
      this.loading = true
      findDisplayOperationList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
      findDisplayOperationStatistics(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'dates', getLastWeekDates())
    },
    closeDialog () {
      this.addForm = {
      }
      this.imgLis = []
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.addForm.quantity && this.addForm.amount) {
          this.$set(this.addForm, 'unitPrice', toFixed(this.addForm.amount / this.addForm.quantity, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 200px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.width1  /deep/.el-input .el-input__inner {
    width: 480px;
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
 /deep/.el-form {
  width: 100%;
 }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
